import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
import TabViewModel from "./../factories/tab-controller";
import MandatorUserTab from "./tabs/mandator-user-tab";
import TabPage from "./../factories/tab-page";

// bao migrate - module not found: import Synoset from "modules/synoset-module";

function MandatorViewModel(tabPage) {

    var self = this;
    SearchPaging.call(this, tabPage);
    self.TabViewModel = new TabViewModel(false);


    /*
     * creates the Tab-Page for User:
    */
    var tabPageUser = new TabPage();
    tabPageUser.AutoSelect = true;
    tabPageUser.Url("MandatorUserTab/Index");
    tabPageUser.Title = Bao.Session.GetMessage("msgUserTabTitle");
    tabPageUser.IsClosable(false);
    tabPageUser.ViewModel(new MandatorUserTab(tabPageUser, self));
    tabPageUser.TabLoaded = function () {
        tabPageUser.ViewModel().Refresh();
    };

    /*
     * loading function for Mandator
     * Add the User Tab to the View
    */
    var baseLoaded = self.loaded;
    self.loaded = function () {
        // add user-tab:
        self.TabViewModel.AddTab(tabPageUser);
        // call base load:
        if (baseLoaded != null) {
            baseLoaded.call(self);
        }
    };


    /*
     * Save Method for Mandator and Tabs
    */
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            sessionTabId: self.TabPage.SessionTabId,
            model: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.TabViewModel.SaveTabs(value.Result).then(function () {
                tabPage.DirtyFlag(false);
                self.PerformRefresh();
                self.TabViewModel.RefreshTabs();
            });
        });
    };

    /*
     * complete Check for Mandator
    */
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };

}
Bao.inherit(MandatorViewModel, SearchPaging);
MandatorViewModel.prototype.PrimaryKey = "MandatorId";
MandatorViewModel.prototype.RefreshUrl = "Mandator/Get";
MandatorViewModel.prototype.SaveUrl = "Mandator/Save";
MandatorViewModel.prototype.DeleteUrl = "Mandator/Delete";
MandatorViewModel.prototype.IsInUseUrl = "Mandator/IsInUse";
MandatorViewModel.prototype.PermissionForward = "MandatorMoveForwardSearch";
MandatorViewModel.prototype.PermissionBackward = "MandatorMoveBackwardSearch";
MandatorViewModel.prototype.PermissionSave = "MandatorSave";
MandatorViewModel.prototype.PermissionRefresh = "MandatorRefresh";
MandatorViewModel.prototype.PermissionDelete = "MandatorDelete";
export default MandatorViewModel;